var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("field_color", {
    model: {
      value: _vm.bgcolor,
      callback: function($$v) {
        _vm.bgcolor = $$v
      },
      expression: "bgcolor"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }